import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const useYearsLabel = () => {
	const { t } = useResource();

	return (years: number) => t(Resources.Calculators.Years, { count: years });
};
